import diyLightTheme = require('./diyLightTheme');

const muiAutoprefixer: any = require<any>('material-ui/utils/autoprefixer').default;

interface Autoprefixer {
    (rules: React.CSSProperties): React.CSSProperties;
}

export const autoprefixer = muiAutoprefixer(diyLightTheme) as Autoprefixer;



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/material-ui/autoprefixer.ts
 **/